import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SigninService } from '../../../services/signin.service';
import { AlertService } from '../../../providers/alert.service';
import * as $ from "jquery";
import uuid from 'uuid';

@Component({
    selector: 'app-slider-captcha',
    template: require('./slider-captcha.component.html'),
    styles: [require('./slider-captcha.component.scss')]
})
export class SliderCaptchaComponent implements OnInit, OnChanges {

    checkCode;
    strTip: string;
    /** 验证是否通过 */
    isCheckOk: boolean;

    noticeMsg: string;
    captchaUrl: string;
    /** 验证码显示路径 */
    isLoadingUrl: boolean;
    /** 点击的文字个数统计 */
    checkCodeNumber: number;
    /** 是否显示验证码图片 */
    showCaptchaImg: boolean;
    catchId: string;
    @Input('validateStatus') validateStatus: boolean;
    @Output() validateStatusChange = new EventEmitter<{ param1: boolean, param2: object }>()
    // @Output() createIdEvent: EventEmitter<string> = new EventEmitter<string>();
    @Output() closeRegModal = new EventEmitter();

    constructor(
        private alertService: AlertService,
        private signinService: SigninService,
    ) {
    }

    getUid() {
        this.catchId = uuid();
        // this.createIdEvent.emit(this.catchId);
        return this.catchId;
    }

    /**
     * 
     *
     * @param {SimpleChanges} changes
     * @memberof SliderCaptchaComponent
     */
    ngOnChanges(changes: SimpleChanges): void {
        for (let propName in changes) {
            if (propName === "validateStatus") {
                const tempParams = changes["validateStatus"].currentValue;
                if (!tempParams) {
                    this.noticeMsg = '点此进行验证';
                    this.btnRefresh();
                }
            }
        }
    }

    ngOnInit(): void {
        this.isLoadingUrl = true;
        this.checkCode = [];
        this.captchaUrl = '';
        this.isCheckOk = false;
        this.catchId = this.getUid();
        this.checkCodeNumber = 1;
        this.showCaptchaImg = false;
        this.noticeMsg = '点此进行验证';
        this.strTip = '点此进行验证';
        this.getCaptchaUrl();
    }

    /**
     * 刷新验证码图片路径
     * Evan 2020-03-16
     * @memberof SliderCaptchaComponent
     */
    getCaptchaUrl() {
        const params = { catchId: this.catchId };
        this.signinService.getVerificationCodeImage(params).then(res => {
            this.isLoadingUrl = false;
            if (res.Result) {
                this.strTip = res.Parameter;
                this.captchaUrl = res.Error;
            } else {
                this.alertService.errorAlert(res.Error);
            }
        }).catch(err => {
            this.isLoadingUrl = false;
            this.alertService.errorAlert(err.Error);
        });
    }

    /**
     * 
     * 
     * @memberof SliderCaptchaComponent
     */
    showCaptchaEvent() {
        this.isCheckOk == true ? this.showCaptchaImg = false : this.showCaptchaImg = true;
        // this.getCaptchaUrl();
    }

    /**
     * 验证码点击获取鼠标地址
     * Evan 2020-03-17
     * @memberof SliderCaptchaComponent
     */
    captchaImgClick($event) {
        let pos = this.getMousePosition($event.target, event);
        this.createPoint(pos);
    }

    /**
     * 
     * Evan 2020-03-17
     * @memberof SliderCaptchaComponent
     */
    createPoint(pos) {
        if (this.checkCodeNumber === 2) {
            this.checkCodeValidate();
        }
        let newElement = document.createElement('div');
        newElement.setAttribute("onclick", "pointClick(this)");
        newElement.setAttribute("class", "point-area");
        newElement.style.color = '#fff';
        newElement.style.width = 28 + 'px';
        newElement.style.height = 28 + 'px';
        newElement.style.borderRadius = '50%';
        newElement.style.textAlign = 'center';
        newElement.style.position = 'absolute';
        newElement.style.lineHeight = 28 + 'px';
        newElement.style.top = (pos.y + 25) + 'px';
        newElement.style.left = (pos.x + 10) + 'px';
        newElement.style.border = '1px solid white';
        newElement.style.backgroundColor = '#88affd';
        newElement.innerText = this.checkCodeNumber.toString();
        $('.bg-img').append(newElement)
        // document.getElementById("captcha-img").appendChild(newElement);
        ++this.checkCodeNumber;

    }

    /**
     * 验证用户信息
     * Evan 2020-03-17
     * @memberof SliderCaptchaComponent
     */
    checkCodeValidate() {
        const params = JSON.stringify({ code: this.checkCode, catchId: this.catchId });
        this.signinService.postVerificationCheck(params).then(res => {
            if (res && res.Result) {
                this.validateStatusChange.emit({ param1: res.Result, param2: { code: this.checkCode, catchId: this.catchId } });
                this.isCheckOk = res.Result;
                this.noticeMsg = res.Error;
            } else {
                this.noticeMsg = '点此进行验证';
                this.btnRefresh();
                this.validateStatusChange.emit({ param1: false, param2: { code: this.checkCode, catchId: this.catchId } });

            }
        }).catch(err => {
            this.showCaptchaImg = false;
            this.validateStatusChange.emit({ param1: false, param2: { code: this.checkCode, catchId: this.catchId } });
            this.btnRefresh();
        });
    }

    /**
     * 获取鼠标坐标位置
     * Evan 2020-03-17
     * @param {*} e
     * @memberof SliderCaptchaComponent
     */
    getMousePosition(obj, event) {
        const ev: MouseEvent = event || window.event;
        const x = ev.clientX - ($(obj).offset().left - $(window).scrollLeft()+ obj.offsetLeft);
        const y = ev.clientY - ($(obj).offset().top - $(window).scrollTop());
        this.checkCode.push({ "_X": parseInt(x + ''), "_Y": parseInt(y + '') });
        return { 'x': parseInt(x + ''), 'y': parseInt(y + '') };
    }

    /**
     * 刷新验证码图片
     * Evan 2020-03-17 
     * @memberof SliderCaptchaComponent
     */
    btnRefresh() {
        this.isCheckOk = false;
        this.isLoadingUrl = true;
        this.checkCodeNumber = 1;
        this.checkCode = [];
        $(".point-area").remove();
        this.getUid();
        this.getCaptchaUrl();
    }
    CloseModal() {
        this.closeRegModal.emit(true);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/login/slider-captcha/slider-captcha.component.ts